import { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Bugsnag from '@bugsnag/js';
import { padStart, size } from 'lodash';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import * as S from './styles';
import * as CXT from 'context/globalContext';
import 'firebase/analytics';
import { cnpjMask, cpfMask, unMask } from 'utils/mask';
import { Header } from 'components/Header';
import { findData } from 'services/findCEP';
import Button from 'components/Button';
import MaskedInput from 'components/MaskedInput';

import { PopUpDanger } from '../Register/components/PopUpDanger';
import { PopUpWarning } from '../Register/PopUpWarning';

import { TitleWrapperRegisterUpdate } from './components/TitleWrapperRegisterUpdate';

import PessoaFisicaForm from './pessoa-fisica';
import PessoaJuridicaForm from './pessoa-juridica';
import CpfCnpjInputSection from './components/CpfCnpjInputSection';

Bugsnag.start({
  apiKey: '00621c4c68a1b2bd34e7458c0f8d29bc',
  plugins: [new BugsnagPluginReact()],
});

export default function ClientRegisterUpdate() {
  const history = useHistory();
  const globalContext = useContext(CXT.Context);

  const [identifier, setIdentifier] = useState<string>('');
  const [identifierType, setIdentifierType] = useState<'cpf' | 'cnpj'>('cpf');
  const [showForm, setShowForm] = useState<boolean>(false);

  const [municipios, setMunicipios] = useState<any[]>([]);
  const [popUpDangerActive, setPopUpDangerActive] = useState<boolean>(false);

  useEffect(() => {
    getOptions();

    const cpfCnpjCliente = localStorage.getItem('pedido_cpfcnpj');
    const isComingFromOtherPage = localStorage.getItem('auto_go_back');
    if (cpfCnpjCliente && isComingFromOtherPage) {
      triggerLoadData(cpfCnpjCliente);
    }

    return () => {
      localStorage.removeItem('pedido_cpfcnpj');
      localStorage.removeItem('auto_go_back');
    };
  }, []);

  async function getOptions() {
    findData
      .GetMunicipio()
      .then((response) => {
        setMunicipios(response.data.data);
      })
      .catch((err) => {
        Bugsnag.notify(err);
        toast.error('Erro ao carregar os municípios');
      });
  }

  const onFinish = () => {
    if (localStorage.getItem('auto_go_back')) {
      history.goBack();
    }
  };

  const triggerLoadData = (cpfCnpj?: string, type?: 'cpf' | 'cnpj') => {
    if (!cpfCnpj) {
      cpfCnpj = identifier;
    }

    if (cpfCnpj) {
      const unmasked = unMask(cpfCnpj, '[^0-9A-Za-z]').toUpperCase();
      const isCnpj =
        type === 'cnpj' || size(unmasked) > 11 || /[A-Za-z]/.test(unmasked);
      if (isCnpj) {
        cpfCnpj = padStart(cpfCnpj, 14, '0');
        setIdentifierType('cnpj');
      } else {
        cpfCnpj = padStart(cpfCnpj, 11, '0');
        setIdentifierType('cpf');
      }
      setIdentifier(cpfCnpj);
      setShowForm(true);
    }
  };

  const handleChangeCpfCnpj = (event: any) => {
    const value = unMask(event.target.value, '[^0-9A-Za-z]');

    let newValue;
    if (size(value) > 11 || /[A-Za-z]/.test(value)) {
      setIdentifierType('cnpj');
      newValue = cnpjMask(event.target.value);
    } else {
      newValue = cpfMask(event.target.value);
      setIdentifierType('cpf');
    }
    setIdentifier(newValue);
  };

  return (
    <>
      <Header onRefreshClick={getOptions} />
      <S.Wrapper>
        <TitleWrapperRegisterUpdate />
        {!showForm && (
          <CpfCnpjInputSection
            title="CPF/CNPJ do Cliente para edição"
            buttonLabel="Carregar cadastro"
            onSubmit={triggerLoadData}
            onGoBack={() => history.goBack()}
            defaultValue={identifier}
          />
        )}

        {showForm && identifierType === 'cpf' && (
          <PessoaFisicaForm
            key={`client-${identifier}`}
            role="client"
            customerCpf={identifier}
            municipios={municipios}
            finishCallback={onFinish}
            submitButtonLabel="ATUALIZAR CADASTRO"
          />
        )}
        {showForm && identifierType === 'cnpj' && (
          <PessoaJuridicaForm
            customerCnpj={identifier}
            municipios={municipios}
            finishCallback={onFinish}
            submitButtonLabel="ATUALIZAR CADASTRO"
          />
        )}
        {popUpDangerActive && (
          <PopUpDanger setPopUpDangerActive={setPopUpDangerActive} />
        )}
      </S.Wrapper>
      {globalContext.warningData.isActive && (
        <PopUpWarning
          title={globalContext.warningData.title}
          label={globalContext.warningData.label}
          isVehicleName={globalContext.warningData.isVehicleName}
          setWarningData={globalContext.setWarningData}
          outOfOrderVehicle={globalContext.warningData.outOfOrderVehicle}
          returnMessageVehicle={globalContext.warningData.returnMessageVehicle}
        />
      )}
      {/* <ShowPopUp handleCheckId={handleCheckId} /> */}
    </>
  );
}
